import {ResponseFilter} from 'com/gongxigames/math/core/client/ResponseFilter';
import {Session} from 'com/gongxigames/math/core/game/session/Session';
import {Message} from 'com/gongxigames/math/core/game/message/Message';
import {Spin} from 'com/gongxigames/math/core/game/Spin';
import {Field} from 'com/gongxigames/math/core/game/message/Field';

export class AbstractFilter implements ResponseFilter<Session> {
    private static counter = 0;
    public readonly id: number = AbstractFilter.counter++;
    public name: string;

    constructor(name: string) {
        this.name = name;
    }

    public filter(response: Message, session: Session): boolean {
        return false;
    }

    public init(): void {
    }

    protected getTypeWin(response: Message, type: number): number {
        let win = 0;

        for (const pay of this.getSpin(response).pays) {
            if (pay.type === type) {
                win += pay.win;
            }
        }

        return win;
    }

    protected getSymbolWin(response: Message, type: number, symbol: number): number {
        let win = 0;

        for (const pay of this.getSpin(response).pays) {
            if (pay.type === type && pay.symbolId === symbol) {
                win += pay.win;
            }
        }

        return win;
    }

    protected getSpin(response: Message): Spin {
        return response.getField(Field.SPIN) as Spin;
    }
}